import { render, staticRenderFns } from "./Performancedeclaration.vue?vue&type=template&id=2b5da1d6&scoped=true"
import script from "./Performancedeclaration.vue?vue&type=script&lang=js"
export * from "./Performancedeclaration.vue?vue&type=script&lang=js"
import style0 from "./Performancedeclaration.vue?vue&type=style&index=0&id=2b5da1d6&prod&lang=less&scoped=true"
import style1 from "./Performancedeclaration.vue?vue&type=style&index=1&id=2b5da1d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5da1d6",
  null
  
)

export default component.exports